console.log('test');
  var _jsbody = document.querySelector('body');
  var _bdClass = _jsbody.classList;
  var _jqbody = $('body');


  function bodyClass(className) {
    return _bdClass.contains(className);
  }

  function detect() {
    if ( innerWidth > 769 ) return 'pc';
    else return 'sp';
  }
  function detect02() {
    if ( innerWidth < 961 ) return 'sp';
    else return 'pc';
  }

/* MEMO: 20210212 - 蛻ｷ譁ｰ荳ｭ
  function pageTopBtn() {
    var scrollSpeed = 500; // scroll speed
    var timing = 500; // button show timing
    var pageTop = $('.btn_pageTop');
    var scTimer;

    var scrollTop = function(x, y) {
      if (y >= 1) {
        var scTop = Math.floor( y - ( y / (7 * 2) ) );
        window.scrollTo(x, scTop);
        scTimer = setTimeout(function(){
          scrollTop(x, scTop)
        }, 7);
      } else {
        clearTimeout(scTimer);
        window.scrollTo(x, 0);
      }
    }

    pageTop.click(function(){
      var x = _jsbody.scrollLeft || document.documentElement.scrollLeft;
      var y = _jsbody.scrollTop  || document.documentElement.scrollTop;
      scrollTop(x, y);
      return false;
    });

    function callback() {
      if ( $(this).scrollTop() > timing ) {
        if ( !pageTop.is('.-visible') ) {
          pageTop.addClass('-visible');
        }
      } else {
        if ( pageTop.is('.-visible') ) {
          pageTop.removeClass('-visible');
        }
      }
    }
    addEventListener('scroll', callback);
    addEventListener('load', callback);
  }



  function spMenu() {
    $('.btn_spMenu').click(function(){
      $('.btn_spMenu').toggleClass('-active');
      _jqbody.toggleClass('-spMenuOpn');
      $('._spMenu').toggleClass('-spMenuOpn');
    });
  }
*/


  function dl_changeTab() {
    $('.dl_changeTab__btn').click(function(){

      var _this = $(this).parent();
      var next = $(this).parent().next();
      var head = $('.dl_changeTab__head');
      var data = $('.dl_changeTab__data');
      var position = _this.offset().top - 100;

      if($('body').hasClass('p-iso_jhc')){
        if ( detect02() == 'pc' ) {
          head.removeClass('-active');
          _this.addClass('-active');
          head.removeClass('-active_sp');
          data.hide();
          next.fadeIn();
        } else {
          _this.toggleClass('-active_sp');
          _this.removeClass('-active');
          next.toggle();
          $('body,html').animate({scrollTop:position}, 500, 'swing');
        }
      }else{
          if ( detect() == 'pc' ) {
          head.removeClass('-active');
          _this.addClass('-active');
          head.removeClass('-active_sp');
          data.hide();
          next.fadeIn();
        } else {
          _this.toggleClass('-active_sp');
          _this.removeClass('-active');
          next.toggle();
          $('body,html').animate({scrollTop:position}, 500, 'swing');
        }
      }

    });
  }




  // debug();
  if ( detect() == 'sp' ) {
    //pageTopBtn();
  }
  //spMenu();
  dl_changeTab();



  addEventListener('load', function() {
    // viewport();
  });

  addEventListener('resize', function() {
    // viewport();
  });

  // if ( bodyClass('single') ) {
  //   console.log('single!');
  // }


  (function ($page) {
    if (!$page.length) return;

    $('.kv_slider').on('init', function () {
      $(this).addClass('initialized');
    });

  })($(".home"));


  (function ($modal) {
    if (!$modal.length) return;

    var isocal_items =
        [
          {
            "type": "isocaljhc_apple",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫ�篠ｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繧翫ｓ縺泌袖", "onlineshop": "https://order.nestle.jp/ec/000945115301.html", "amazon": "https://www.amazon.co.jp/dp/B08H832YZJ?ref=myi_title_dp", "rakuten": "https://item.rakuten.co.jp/nestle/apple24mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/apple24mset.html" }
            ]
          },
          {
            "type": "isocaljhc_peach",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫ�篠ｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繧ゅｂ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000945115401.html", "amazon": "https://www.amazon.co.jp/dp/B08H81S245?ref=myi_title_dp", "rakuten": "https://item.rakuten.co.jp/nestle/peach24mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/peach24mset.html" }
            ]
          },
          {
            "type": "isocaljhc_azuki",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫ�篠ｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲縺ゅ★縺榊袖", "onlineshop": "https://order.nestle.jp/ec/000940290801.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｸ繧ｧ繝ｪ繝ｼ-66gﾃ�24蛟�/dp/B00OK9NPLS/", "rakuten": "https://item.rakuten.co.jp/nestle/0009402908mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009402908mset.html" }
            ]
          },
          {
            "type": "isocaljhc_coffee",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繧ｳ繝ｼ繝偵�蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000945110101.html", "amazon": "https://www.amazon.co.jp/繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｸ繧ｧ繝ｪ繝ｼ-HC-繧ｳ繝ｼ繝偵�蜻ｳ-24蛟九そ繝�ヨ/dp/B07J2G9CM4/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451101mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451101mset.html" }
            ]
          },
          {
            "type": "isocaljhc_chocolate",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繝√Ι繧ｳ繝ｬ繝ｼ繝亥袖", "onlineshop": "https://order.nestle.jp/ec/000940290901.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繝√Ι繧ｳ繝ｬ繝ｼ繝亥袖-66gﾃ�24蛟�/dp/B00OTAO28I/", "rakuten": "https://item.rakuten.co.jp/nestle/0009402909mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009402909mset.html" }
            ]
          },
          {
            "type": "isocaljhc_tofu",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲縺ｨ縺��蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000940299801.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｸ繧ｧ繝ｪ繝ｼ-66gﾃ�24蛟�/dp/B00OT9PRH4/", "rakuten": "https://item.rakuten.co.jp/nestle/0009402998mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009402998mset.html" }
            ]
          },
          {
            "type": "isocaljhc_potato",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繧ｹ繧､繝ｼ繝医�繝�ヨ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000940299901.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｹ繧､繝ｼ繝医�繝�ヨ蜻ｳ-66gﾃ�24蛟�/dp/B00OTAL10U/", "rakuten": "https://item.rakuten.co.jp/nestle/0009402999mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009402999mset.html" }
            ]
          },
          {
            "type": "isocaljhc_kokutou",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲鮟堤ｳ夜｢ｨ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000940291001.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｸ繧ｧ繝ｪ繝ｼ-66gﾃ�24蛟�/dp/B00L91N3D0/", "rakuten": "https://item.rakuten.co.jp/nestle/0009402910mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009402910mset.html" }
            ]
          },
          {
            "type": "isocaljhc_kinako",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲縺阪↑縺灘袖", "onlineshop": "https://order.nestle.jp/ec/000940291401.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｸ繧ｧ繝ｪ繝ｼ-66gﾃ�24蛟�/dp/B00L91QH38/", "rakuten": "https://item.rakuten.co.jp/nestle/0009402914mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009402914mset.html" }
            ]
          },
          {
            "type": "isocaljhc_cheese",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繝ｬ繧｢繝√�繧ｺ繧ｱ繝ｼ繧ｭ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000945110201.html", "amazon": "https://www.amazon.co.jp/繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｸ繧ｧ繝ｪ繝ｼ-HC-繝ｬ繧｢繝√�繧ｺ繧ｱ繝ｼ繧ｭ蜻ｳ-24蛟九そ繝�ヨ/dp/B07J2FX9VV/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451102mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451102mset.html" }
            ]
          },
          {
            "type": "isocaljhc_variety",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繝舌Λ繧ｨ繝�ぅ繝代ャ繧ｯ", "onlineshop": "https://order.nestle.jp/ec/0009405033.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繝舌Λ繧ｨ繝�ぅ繝代ャ繧ｯ-蜈ｨ6遞ｮ蜷�4蛟�-66gﾃ�24蛟�/dp/B018DZGJI0/", "rakuten": "https://item.rakuten.co.jp/nestle/000940503324mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/000940503324mset.html" }
            ]
          },
          {
            "type": "isocal100_strawberry",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繧ｹ繝医Ο繝吶Μ繝ｼ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000945112101.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｹ繝医Ο繝吶Μ繝ｼ蜻ｳ-100mlﾃ�24/dp/B07S3S4Y2D/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451121mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451121mset.html" }
            ]
          },
          {
            "type": "isocal100_coffee",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繧ｳ繝ｼ繝偵�蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/000945112001.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繧ｳ繝ｼ繝偵�蜻ｳ-100mlﾃ�24/dp/B07S1L7W6X/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451120mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451120mset.html" }
            ]
          },
          {
            "type": "isocal100_banana",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繝舌リ繝雁袖", "onlineshop": "https://order.nestle.jp/ec/000945112201.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-繝舌リ繝雁袖-100mlﾃ�24/dp/B07S1LBVM8/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451122mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451122mset.html" }
            ]
          },
          {
            "type": "isocal100_azuki",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 縺ゅ★縺榊袖", "onlineshop": "https://order.nestle.jp/ec/000945112301.html", "amazon": "https://www.amazon.co.jp/Nestle-繝阪せ繝ｬ-繧｢繧､繧ｽ繧ｫ繝ｫ-縺ゅ★縺榊袖-100mlﾃ�24/dp/B07RYJVYYS/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451123mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451123mset.html" }
            ]
          },
          {
            "type": "isocal100_cafemoca",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繧ｫ繝輔ぉ繝｢繧ｫ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/b000000887.html", "amazon": "https://www.amazon.co.jp/dp/B084WRMMYJ", "rakuten": "https://item.rakuten.co.jp/nestle/0009451141mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451141mset.html" }
            ]
          },
          {
            "type": "isocal100_milktea",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繝溘Ν繧ｯ繝�ぅ繝ｼ蜻ｳ", "onlineshop": "https://order.nestle.jp/ec/b000000886.html", "amazon": "https://www.amazon.co.jp/dp/B084WVZJTW", "rakuten": "https://item.rakuten.co.jp/nestle/0009451140mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451140mset.html" }
            ]
          },
          {
            "type": "isocal100_cornsoup",
            "product": [
              {
	              "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繧ｳ繝ｼ繝ｳ繧ｹ繝ｼ繝怜袖",
	              "onlineshop": "",
	              "amazon": "",
	              "rakuten": "",
	              "first": ""
	          }
            ]
          },
          {
            "type": "isocal100_variety",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 100 繝舌Λ繧ｨ繝�ぅ繝代ャ繧ｯ", "onlineshop": "https://order.nestle.jp/ec/000945116401.html", "amazon": "https://www.amazon.co.jp/dp/B07S3RR8R5/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451124mset/", "first": "https://store.shopping.yahoo.co.jp/nestle/0009451124mset.html" }
            ]
          },
          {
            "type": "variety",
            "product": [
              { "name": "繧｢繧､繧ｽ繧ｫ繝ｫﾂｮ 繧ｼ繝ｪ繝ｼ 繝上う繧ｫ繝ｭ繝ｪ繝ｼ縲繝舌Λ繧ｨ繝�ぅ繝代ャ繧ｯ", "onlineshop": "https://order.nestle.jp/ec/0009451149.html", "amazon": "https://www.amazon.co.jp/Nestle-%E3%83%8D%E3%82%B9%E3%83%AC-%E3%83%8F%E3%82%A4%E3%82%AB%E3%83%AD%E3%83%AA%E3%83%BC-%E3%83%90%E3%83%A9%E3%82%A8%E3%83%86%E3%82%A3%E3%83%91%E3%83%83%E3%82%AF-8%E7%A8%AE%C3%97%E5%90%843%E5%80%8B%E3%82%BB%E3%83%83%E3%83%88/dp/B087MFJ2BW/", "rakuten": "https://item.rakuten.co.jp/nestle/0009451149mset/", "first": "https://store.shopping.yahoo.co.jp/pastelcolour/b087mfj2bw.html" }
            ]
          }
        ];

    $('.modalTrigger').on('click', function (e) {
      e.preventDefault();

      var data_modal = $(this).data('modalTrigger');
      var product_pic = $('.modalArea.-secondary').find('.modal_productItem_picImg'),
          productl_name = $('.modalArea.-secondary').find('.modal_productItem_name'),
          online_btn = $('.modalArea.-secondary').find('.modal_productItem_btn.onlineshop'),
          amazon_btn = $('.modalArea.-secondary').find('.modal_productItem_btn.amazon'),
          rakuten_btn = $('.modalArea.-secondary').find('.modal_productItem_btn.rakuten'),
          yahoo_btn = $('.modalArea.-secondary').find('.modal_productItem_btn.first');
      var pic_url = $(this).parents('.listItem').find('.itemVisualImg').attr('src');

      function modal_setting() {
        product_pic.attr('src', '');
        for (var i in isocal_items) {
          if (data_modal == isocal_items[i].type) {
            for (var j in isocal_items[i].product) {
              product_pic.attr('src', pic_url).addClass(data_modal);
              productl_name.text(isocal_items[i].product[j].name);
              online_btn.attr('href', isocal_items[i].product[j].onlineshop);
              amazon_btn.attr('href', isocal_items[i].product[j].amazon);
              rakuten_btn.attr('href', isocal_items[i].product[j].rakuten);
              yahoo_btn.attr('href', isocal_items[i].product[j].first);
            }
          }
        }
      };

      if (data_modal) {
        modal_setting();
        $('.modalArea.-secondary').addClass('-opened');
      } else {
        $('.modalArea.-primary').addClass('-opened');
      }
      $('.menu_btn').addClass('menu-hidden');
    });


    $('.modalBg, .modalClose').on('click', function (e) {
      $('.modalArea').removeClass('-opened');
      $('.menu_btn').removeClass('menu-hidden');
    });

  })($(".modalArea"));


$(function($){
  var win_width = $(window).width();

  //fadein animation
  $(function(){
    $(window).on('load scroll',function(){
      var ws = $(window).scrollTop();
      var wh = $(window).height();
      var hh = $(".siteHeader").height();
      $(".fade-in").each(function(){

        var os = $(this).offset().top;
        if (ws > os - wh + wh/3 ){
          if($(this).hasClass("trialbanner-flag")){
            var tbh = $('.trialbanner-flag').height();
            var tbos = $('.trialbanner-flag').offset().top;
            if(win_width >= 769 && ws > tbos - tbh){
              $(".trialbanner").addClass("on");
            }else if(win_width < 768 && ws > tbos - tbh / 2){
              $(".trialbanner").addClass("on");
            }
          }else{
            $(this).addClass("on");
          }
        }
      });
    });
    $(window).scroll(function (){
    });
  });

  // top section03 toggle
  if($(".renewal.home .section03").length > 0){
    $(".section03 .bt").on('click',function(){
      $(".section03 .toggle01").slideToggle();
      if($(this).hasClass("open")){
        $(this).removeClass("open");
        $(this).children('p').html('<img src="/nutrition/product/isocal/_assets/images/svg/svg030.svg" class="lazy svg svg030" alt="繧ゅ▲縺ｨ隕九ｋ">');
      }else{
        $(this).addClass("open");
        $(this).children('p').html('<img src="/nutrition/product/isocal/_assets/images/svg/svg029.svg" class="lazy svg svg029" alt="謌ｻ縺�">');
      }
    });
  }

  if($(".renewal.home .section05").length > 0){
    $(".qa-bt1").on('click',function(){
      $(".qa-hidden1").slideToggle();
      if($(this).hasClass("open")){
        $(this).removeClass("open");
        $(this).html('<img src="/nutrition/product/isocal/_assets/images/svg/svg072.svg" alt="繧ゅ▲縺ｨ隕九ｋ" class="lazy svg svg072">');
      }else{
        $(this).addClass("open");
        $(this).html('<img src="/nutrition/product/isocal/_assets/images/svg/svg073.svg" alt="謌ｻ縺�" class="lazy svg svg073">');
      }
    });
    $(".qa-bt2").on('click',function(){
      $(".qa-hidden2").slideToggle();
      if($(this).hasClass("open")){
        $(this).removeClass("open");
        $(this).html('<img src="/nutrition/product/isocal/_assets/images/svg/svg072.svg" alt="繧ゅ▲縺ｨ隕九ｋ" class="lazy svg svg072">');
      }else{
        $(this).addClass("open");
        $(this).html('<img src="/nutrition/product/isocal/_assets/images/svg/svg073.svg" alt="謌ｻ縺�" class="lazy svg svg073">');
      }
    });
  }

  $("._gNavList__item").on('click',function(){
    $('.renewal').removeClass('-spMenuOpn');
    $("._spMenu").removeClass('-spMenuOpn');
    $(".sp_ib").removeClass('-active');
  });

  if($(".renewal .following").length > 0){
    $(".following .close").on('click',function(){
      $(".following").css('display', 'none');
      $(".renewal.home").css('padding-bottom', 0);
    });
  }

  if($(".renewal").length > 0 || $("#icl-clear").length > 0){
    $('.scroll').on('click',function(e){
      $('.renewal').removeClass('-spMenuOpn');
      e.preventDefault();
      var BPMax1024 = window.matchMedia('(max-width:1024px)');
      var targetHref = $(this).attr('href');
      if (targetHref.startsWith("http") || targetHref.startsWith("/")) {
        window.location.href = targetHref;
        return;
      }
      var target = $(targetHref == '#' || targetHref == '' ? 'html' : targetHref);
      $('#icl-clear').removeClass("-spMenuOpn");
      if(win_width > 750){
        var targetCoord = target.offset().top - 100;
      }else{
        if($('body').hasClass('home')){
          if($(this).parent().hasClass('-qa')||$(this).parent().hasClass('qa')){
            var targetCoord = target.offset().top - 80;
          }else{
            var targetCoord = target.offset().top ;
          }
        }else{
          if($(this).parent().hasClass('-qa')){
            var targetCoord = target.offset().top - 130;
          }else{
            var targetCoord = target.offset().top - 50;
          }

        }
      }
      var targetPadding = parseInt($(target).css("paddingTop"));

      $('html,body').animate({scrollTop:targetCoord}, 500);
    });
  }

  $("img.lazy").lazyload({threshold: 300});

  // recipe mainvisual
  $(window).on('load', function() {
    $(".mainvisual").addClass('on');
  });
  // recipe toggle
  function recipeToggle(place1,place2){
    $(place2).removeClass('display');
    $(place1).slideToggle();
    var contentsOffset = $(place2).offset().top;
    $('html,body').animate({scrollTop:contentsOffset - 125}, 400);
  }

  $(".recipe-open-btn").on('click',function(){
    $(this).addClass('hide');
    if($(this).hasClass("recipe-open-btn01")){
      $(".recipe-contents01").slideToggle();
      $(".recipe01").addClass('display');
      $(".recipe-close-btn01").addClass('display');
    }else if($(this).hasClass("recipe-open-btn02")){
      $(".recipe-contents02").slideToggle();
      $(".recipe02").addClass('display');
      $(".recipe-close-btn02").addClass('display');
    }else if($(this).hasClass("recipe-open-btn03")){
      $(".recipe-contents03").slideToggle();
      $(".recipe03").addClass('display');
      $(".recipe-close-btn03").addClass('display');
    }else if($(this).hasClass("recipe-open-btn04")){
      $(".recipe-contents04").slideToggle();
      $(".recipe04").addClass('display');
      $(".recipe-close-btn04").addClass('display');
    }
  });

  $(".recipe-close-btn").on('click',function(){
    $(this).removeClass('display');
    if($(this).hasClass("recipe-close-btn01")){
      recipeToggle(".recipe-contents01",".recipe01");
      $(".recipe-open-btn01").removeClass('hide');
    }else if($(this).hasClass("recipe-close-btn02")){
      recipeToggle(".recipe-contents02",".recipe02");
      $(".recipe-open-btn02").removeClass('hide');
    }else if($(this).hasClass("recipe-close-btn03")){
      recipeToggle(".recipe-contents03",".recipe03");
      $(".recipe-open-btn03").removeClass('hide');
    }else if($(this).hasClass("recipe-close-btn04")){
      recipeToggle(".recipe-contents04",".recipe04");
      $(".recipe-open-btn04").removeClass('hide');
    }
  });

  //slide 驕�ｻｶ隱ｭ縺ｿ霎ｼ縺ｿ
  var interval_id = setInterval(function() {
    if (document.readyState !== "complete") return;
    clearInterval(interval_id);
    //縺薙％縺ｫ繝ｭ繝ｼ繝牙ｾ後�蜃ｦ逅�ｒ譖ｸ縺�
    $('.slide02').attr('src', '/nutrition/product/isocal/_assets/images/top/img_topKv_slide2.png');
    $('.slide03').attr('src', '/nutrition/product/isocal/_assets/images/top/img_topKv_slide3.png');
    $('.slide02-sp').attr('src', '/nutrition/product/isocal/_assets/images/top/img_topKv_slide2_sp.png');
    $('.slide03-sp').attr('src', '/nutrition/product/isocal/_assets/images/top/img_topKv_slide3_sp.png');
  }, 100);

  $(".more").on('click',function(){
    if($(this).hasClass('open')){
      $(this).removeClass('open');
      $("#gift-campaign .open").css('display','none');
      $("#gift-campaign .close").css('display','block');
      $("#gift-campaign .add").slideToggle();
    }else{
      $(this).addClass('open');
      $("#gift-campaign .open").css('display','block');
      $("#gift-campaign .close").css('display','none');
      $("#gift-campaign .add").slideToggle();
    }
  });

  //clear mainvisual height
/*
  $(window).on( 'load resize', function(){
    if($("#icl-clear").length > 0){
      win_width = $(window).width();

      if(win_width > 930){
        var mainvisual_height = $(".mainvisual-wrap img.pc").height();
        var mainvisual_wrap_height = $(".mainvisual-wrap").height();
        if(mainvisual_wrap_height > mainvisual_height){
          $(".mainvisual-wrap").css("height", mainvisual_height);
          $(".mainvisual").css("height", mainvisual_height);
        }else{
          $(".mainvisual-wrap").css("height", "100%");
          $(".mainvisual").css("height", "calc(100vh - 190px)");
        }
      }else{
        $(".mainvisual-wrap").css("height", "auto");
        $(".mainvisual").css("height", "auto");
      }
    }
  });
*/

  //clear menu side_bar{
  if($("#icl-clear").length > 0){
    $(".close").on('click',function(){
      $('#icl-clear').removeClass("-spMenuOpn");
    });
    //$('.data03').children('.dl_changeTab__dataInner').jScrollPane();
    $(".dl_changeTab__btn").on('click',function(){
      var _this = $(this).parent();
      var next = $(this).parent().next();
      $(function(){
        //$(next).children('.dl_changeTab__dataInner').jScrollPane();
      });
    });
  }
  //clear QandA 繝医げ繝ｫ
  if($("#icl-clear").length > 0){
    $(".qa-toggle-btn").on('click',function(){
      $(".qa-hidden").slideToggle();
      if($(this).hasClass("open")){
        $(this).removeClass("open");
        $(this).html('<p>開く</p>');
      }else{
        $(this).addClass("open");
        $(this).html('<p>閉じる</p>');
      }
    });
  }
});

$(window).on( 'load', function youtube_defer() {
  var iframes = document.querySelectorAll('.youtube');

  var iframes = Array.prototype.slice.call(iframes,0);
  iframes.forEach(function(iframe){
    if(iframe.getAttribute('data-src')) {
      iframe.setAttribute('src',iframe.getAttribute('data-src'));
    }
  });

});

$(document).ready(function(){
  $("li.-nutrition").click(function(){
     $(".section03 .bt").addClass("open");
      $(".toggle-block.toggle01").css("display", "block");
      $(".section03 .bt p").html('<img src="/nutrition/product/isocal/_assets/images/svg/svg029.svg" class="lazy svg svg029" alt="謌ｻ縺�">');
  });

  var url = window.location.href;
  var array = url.split('/');
  var firstsegment = array[array.length-1];
  var secondsegment = array[array.length-2];
  var thirdsegment = array[array.length-3];
  var fourthsegment = array[array.length-4];

  if(firstsegment == "#section03" && secondsegment == "isocal" && thirdsegment == "product" && fourthsegment == "nutrition"){
    $(".section03 .bt").addClass("open");
    $(".toggle-block.toggle01").css("display", "block");
    $(".section03 .bt p").html('<img src="/nutrition/product/isocal/_assets/images/svg/svg029.svg" class="lazy svg svg029" alt="謌ｻ縺�">');
  }
});


$(document).ready(function() {
     var hash = window.location.hash;

     hash = $(hash);
     if(hash.length==0)return;
     var m_top = 100;
     if ($(window).width() < 768) {
          m_top = 0;
      }
  $('html, body').animate({
      scrollTop: hash.offset().top - m_top
      }, {
          duration: 0,
          easing: 'swing'
      });

  });